import { describeFields } from '../common/fields';
import { SchoolSchema } from './schemas';

export const SCHOOL_FIELDS = describeFields(SchoolSchema, {
  schoolId: {},
  label: {},
  shortLabel: {},
  abbreviation: {},
  type: {},
  hscRank: {},
  address: {},
});
